module.exports = __webpack_public_path__ + "static/media/Out_Of_Coins_StaticImage@3x.aabe50ea.png";